// Literal de fallback da origem da API — FONTE ÚNICA.
//
// Mora num módulo próprio, e não junto de quem usa, porque tem DOIS consumidores
// em contextos diferentes:
//   - `src/runtime-config.ts` (runtime): o piso de `API_BASE_BUILD_FALLBACK`, que
//     alimenta o bootstrap do app quando a env de build não veio.
//   - `vite.config.ts` (build): o valor estampado no `<meta app-api>` do
//     index.html quando a env de build não veio.
//
// Se cada lado tivesse a sua cópia, elas poderiam divergir — e a divergência é
// silenciosa E perigosa: o `<meta app-api>` (que o gate de empacotamento lê e o
// diagnóstico no aparelho consulta) anunciaria uma origem que o bundle não usa.
// Um diagnóstico que MENTE é pior que nenhum. Uma const, dois importadores.
//
// Não dá pra `vite.config.ts` importar direto de `runtime-config.ts`: aquele
// módulo executa no load (semeia `active` via makeFallback) e lê
// `import.meta.env`, que não existe no contexto do config. Daí o módulo separado,
// sem side-effect nenhum.
//
// Valor espelha o default do build-arg em apps/tv/Dockerfile.
export const API_ORIGIN_LITERAL_FALLBACK = 'https://api.swipetvplayer.com'

// SEMENTES DE ORIGEM DA API — o PISO de descoberta, embutido no bundle.
//
// POR QUE UM ARRAY, E NÃO UMA URL SÓ
// ----------------------------------
// Uma origem única embutida cobre "pacote nasce morto" (o incidente 2.24.2), mas
// NÃO cobre o caso realmente fatal: `api.swipetvplayer.com` BLOQUEADO por DNS de
// ISP (o vetor "muito comum" de docs/specs/dns-resilience.md §5I.1) numa TV já
// instalada com cache vencido, ou numa instalação LIMPA durante o bloqueio. Nesse
// caso não há a quem perguntar onde está a API — a lista de failover que o config
// remoto serviria vive DENTRO da própria API bloqueada (a circularidade descrita
// na §2 de docs/plan/origem-da-api-sem-rebuild.md). A única camada que sobrevive a
// "tudo remoto inacessível e cache vencido" é uma lista que já veio no pacote.
//
// Cada semente ADICIONAL só ajuda se estiver num APEX DIFERENTE (registrar/DNS
// distintos): um segundo domínio apontando (CNAME) pra mesma origem Easypanel não
// protege contra IP bloqueado nem host fora do ar, mas PROTEGE contra DNS hijack
// de ISP e takedown de registrar — exatamente o vetor dominante. Ver a "nuance
// honesta sobre o segundo domínio" na §3 do plano.
//
// HOJE a lista tem UM elemento porque só existe UM apex (`swipetvplayer.com`). O
// segundo domínio é DECISÃO DO FERNANDO (comprar em registrar diferente — §10.1 do
// plano). Quando existir, some a linha aqui — SEM tocar lógica, SEM rebuild de
// arquitetura: o encadeamento de fontes, o failover em runtime e o piso de
// makeFallback já consomem o array inteiro.
//
// INVARIANTES (guardadas por api-origin-fallback.test.ts, a cada commit):
//   - ≥ 1 semente;
//   - toda semente é origem ABSOLUTA https:// (nunca relativa → nunca file://);
//   - nenhuma termina em barra (concatenada com `/v1/...`);
//   - apexes distintos (semente duplicada é ruído, não resiliência).
//
// A PRIMEIRA semente é sempre o literal — é a que o `<meta app-api>` e o gate de
// empacotamento (scripts/compat/check-api-origin.mjs) anunciam como origem
// primária do artefato.
export const API_ORIGIN_SEEDS: readonly string[] = [
  API_ORIGIN_LITERAL_FALLBACK,
  // Ao comprar o 2º domínio (registrar/DNS distintos), adicione aqui, ex.:
  //   'https://api.swipetvcfg.com',
  // e nada mais muda no cliente.
]
